import { nativeApi } from '../expo/NativeAPI';

const copyWithExecCommand = (text) => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export const copyToClipboard = async (text) => {
  if (nativeApi.isNative) {
    nativeApi.copyToClipboard(text);
    return;
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  copyWithExecCommand(text);
};
